import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-primary-500">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50">
          准备好了吗？
        </h2>
        <p className="mt-3 text-sm md:text-base text-background-50/80 leading-relaxed">
          无论您是训练师、教育者、宠物主人还是自我提升者，调教指南都将伴随您每一步的成长。开始探索，让科学的行为塑造方法为您所用。
        </p>
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/pet-training"
            className="whitespace-nowrap px-6 py-3 text-sm font-medium bg-background-50 text-primary-600 rounded-md hover:bg-background-100 transition-all duration-200 cursor-pointer"
          >
            浏览文章
          </Link>
          <Link
            to="/about"
            className="whitespace-nowrap px-6 py-3 text-sm font-medium bg-primary-600 text-background-50 rounded-md hover:bg-primary-700 transition-all duration-200 cursor-pointer"
          >
            联系我们
          </Link>
        </div>
      </div>
    </section>
  );
}